import React, { FC, useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { showError } from '@bepro-travel/fe.utils';
import { checkPaymentStatus } from '../../service';
import { useGetPage } from '../../hooks/useGetPage';
import { PaymentSkeleton } from '@bepro-travel/fe.shared';
import { useTranslation } from 'react-i18next';

const OphirPaymentPage: FC = () => {
  const [paymentUrl, setPaymentUrl] = useState();
  const [triesCount, setTriesCount] = useState(60);
  const navigate = useNavigate();
  const timeout = useRef<any>();
  const [t] = useTranslation() as unknown as [(key: string) => string];
  useGetPage('/RuTours/BookComplete');

  useEffect(() => {
    const newData = sessionStorage.getItem('ophirPaymentOrder');
    if (newData) {
      const order = JSON.parse(newData);

      if (order?.paymentUrl) {
        check(order?.transactionId);
        setPaymentUrl(order.paymentUrl);
      }
    }
    return () => clearTimeout(timeout.current);
  }, []); // eslint-disable-line

  const check = async (transactionId: string) => {
    setTriesCount((prev) => prev - 1);

    const responseCheck = await checkPaymentStatus(transactionId);

    if (responseCheck?.orderHasBeenPaid) {
      sessionStorage.setItem(
        'ophirSuccessOrder',
        JSON.stringify({ data: responseCheck.bookingModel, creditCard: true, bookingSuccess: true })
      );
      const lang = localStorage.getItem('language') || 'he';
      navigate(lang === 'he' ? '/tour/success' : '/tourru/success');
    } else if (responseCheck?.hasErrors) {
      showError(t('something_went_wrong'));
    } else if (triesCount > 0) {
      timeout.current = setTimeout(() => check(transactionId), 5000);
    }
  };

  return (
    <div
      className="details-wrapper position-relative"
      style={{ justifyContent: 'center', height: 830 }}
    >
      <PaymentSkeleton systemProducts="Hotels" />

      {paymentUrl && (
        <div className="book-payment-wr" dangerouslySetInnerHTML={{ __html: paymentUrl }}></div>
      )}
    </div>
  );
};

export default OphirPaymentPage;
